import { IdEnum, type ITripTerminus } from "@b2bportal/core-types";

export const ZERO_FIAT_AMOUNT = {
  currencyCode: "AED",
  currencySymbol: "AED ",
  value: 0,
};

export const DEFAULT_FLIGHT_ORIGIN: ITripTerminus = {
  id: {
    code: {
      regionType: "airport",
      code: "DXB",
    },
    Id: IdEnum.Flight,
  },
  label: "Dubai (DXB)",
  trackingProperties: {},
};
